import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import { supabase } from '../lib/supabase'
import Logo from '../components/Logo'

export default function Login() {
  const { signIn } = useAuth()
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [info, setInfo] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true); setErr(''); setInfo('')
    const { error } = await signIn(email.trim(), password)
    if (error) { setBusy(false); setErr('Identifiants invalides. Réessayez.'); return }
    const { data: u } = await supabase.auth.getUser()
    const { data: prof } = await supabase.from('profiles').select('role').eq('id', u.user!.id).single()
    setBusy(false)
    nav(prof?.role === 'admin' ? '/admin' : '/portail')
  }

  async function forgot() {
    const target = email.trim() || prompt('Votre adresse courriel :') || ''
    if (!target) return
    setErr(''); setInfo('')
    const { error } = await supabase.auth.resetPasswordForEmail(target.toLowerCase(), { redirectTo: `${window.location.origin}/mot-de-passe` })
    if (error) setErr('Erreur : ' + error.message)
    else setInfo(`Un lien pour choisir un nouveau mot de passe a été envoyé à ${target}. Vérifiez aussi vos indésirables.`)
  }

  const input = 'w-full bg-black/40 border border-white/10 rounded px-4 py-3 text-sm focus:border-orange outline-none'

  return (
    <div className="min-h-screen bg-noir text-blanc flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm">
        <div className="flex justify-center mb-10"><Logo /></div>
        <h1 className="font-display text-3xl tracking-wide text-center mb-1">Espace client</h1>
        <p className="text-acier text-sm text-center mb-8">Accédez à votre espace Pivot Média.</p>
        <label className="block text-xs uppercase tracking-widest text-acier mb-1">Adresse courriel</label>
        <input className={input + ' mb-4'} type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" />
        <label className="block text-xs uppercase tracking-widest text-acier mb-1">Mot de passe</label>
        <input className={input} type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
        {err && <p className="text-red-400 text-sm mt-3">{err}</p>}
        {info && <p className="text-green-300 text-sm mt-3">{info}</p>}
        <button disabled={busy} className="w-full mt-6 bg-orange hover:bg-orange-hover transition-colors py-3 rounded-sm uppercase tracking-widest text-sm font-bold disabled:opacity-40">
          {busy ? 'Connexion…' : 'Se connecter'}
        </button>
        <button type="button" onClick={forgot} className="block w-full text-center text-xs uppercase tracking-widest text-acier hover:text-orange mt-5">Mot de passe oublié ou premier accès ?</button>
        <a href="/" className="block text-center text-xs uppercase tracking-widest text-acier hover:text-orange mt-4">← Retour au site</a>
      </form>
    </div>
  )
}
